



import EventSettingComponent from "@/components/admin/event/eventSettingComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventSettingPage",
  components: {
    EventSettingComponent,
  },
})
export default class EventSettingPage extends Vue {}
